import { useConfig } from '@office-start/config-query-wrapper-service';
import { templatesConfigOptions } from '../options/templatesConfigOptions';
export function useTemplatesConfig() {
    return useConfig(templatesConfigOptions);
}
//# sourceMappingURL=useTemplatesConfig.js.map